import { Text } from 'pcln-design-system'
import styled from 'styled-components'

export const BundleAndSaveText = styled(Text)`
  white-space: nowrap;
`
